import { buildUrl } from "../../utils/url"

export const makeStorageFileApiEndpoints = (fileId = ":fileId") => {
  return {
    presignedUrls: () => "/storage/files/presigned-urls",
    confirmUpload: () => "/storage/file/confirm",
    attachFiles: () => "/storage/files/attach",
    files: (params?: URLSearchParams) => buildUrl("/storage/files", params),
    fileUrl: (id = fileId) => `/storage/file/${id}/url`,
    fileItem: (id = fileId) => `/storage/file/${id}`,
  }
}
